import QRCode from 'qrcodejs2'
// 引入外部sdk
export function importSdk (_url, _cb) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = _url;
    script.addEventListener('load', () => {
        _cb()
    }, false)
    document.getElementsByTagName('head')[0].appendChild(script);
}
// 生成二维码
export function buildQrCode (url, size, id) {
    /* eslint-disable*/
    let qr = new QRCode(id, {
        width: size,
        height: size, // 高度
        text: url,
        render: 'canvas',
        correctLevel : QRCode.CorrectLevel.L
    })
}
